import React from 'react';
import MednaBrand from '../../../config/MednaBrand';

const points = [
  { text: 'Worked in community mental health clinics, private practice, and academic medical centers.', color: '#1a5f4a' },
  { text: 'Expertise in the treatment of mood disorders, anxiety disorders, and psychotic disorders.', color: '#b83d6a' },
  { text: "Special interest in women's mental health and perinatal psychiatry.", color: '#5a4d9e' },
  { text: 'Experience managing complex cases that involve both mental health and medical issues.', color: '#c76b2d' },
];

export default function WhyHRMSSection() {
  return (
    <div
      className="container"
      style={{
        paddingTop: '40px',
        paddingBottom: '32px',
      }}
    >
      <div
        style={{
          maxWidth: '880px',
          margin: '0 auto',
          padding: '40px 44px 44px',
          background: 'linear-gradient(135deg, #0a0f1a 0%, #111827 100%)',
          borderRadius: '8px',
          fontFamily: MednaBrand.fontFamily,
          boxShadow: '0 4px 24px rgba(0,0,0,0.25)',
          border: '1px solid rgba(201, 162, 39, 0.2)',
        }}
      >
        <ul
          style={{
            listStyle: 'none',
            margin: 0,
            padding: 0,
          }}
        >
          {points.map((item, index) => (
            <li
              key={index}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '12px',
                marginBottom: index < points.length - 1 ? '14px' : 0,
                textAlign: 'left',
              }}
            >
              <span
                style={{
                  flexShrink: 0,
                  width: '8px',
                  height: '8px',
                  marginTop: '8px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255,255,255,0.8)',
                }}
                aria-hidden
              />
              <span
                style={{
                  flex: 1,
                  fontSize: '1rem',
                  lineHeight: 1.5,
                  color: '#ffffff',
                  fontWeight: 500,
                }}
              >
                {item.text}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
